import { RouteType } from '../../../types';
import ABTests from './screens/ABTests/ABTests';
import CustomizationItems from './screens/Items';
import CustomizationRoutes from './screens/Items/views';
import LiveShows from './screens/LiveShows';
import MonthlyPass from './screens/MonthlyPass/MonthlyPass';
import Tournament from './screens/Tournament/Tournament';
import SaleEvent from './screens/SaleEvent/SaleEvent';
import SpecialEvent from './screens/SpecialEvent/SpecialEvent';
import HurdleQuiz from './screens/HurdleQuiz/HurdleQuiz';
import ChainedOffer from './screens/ChainedOffer/ChainedOffer';
import LiveEvent from './screens/LiveEvent/LiveEvent';
import TeamShop from './screens/TeamShop/TeamShop';
import Collection from './screens/Collections/Collection';
import WheelFortune from './screens/WheelFortune/WheelFortune';
import Calendar from './screens/PaidCalendar/Calendar';
import Marathon from './screens/Marathon/Marathon';
import LoyaltyCampaign from './screens/LoyaltyCampaign';
import RedeemCodes from './screens/RedeemCodes/RedeemCodes';
import ProgressiveAds from './screens/ProgressiveAds/ProgressiveAds';

export const PREFIX = 'sp3';

const routes: RouteType[] = [
  {
    path: `/${PREFIX}/liveops/monthlypass`,
    name: 'Monthly Pass',
    component: MonthlyPass,
  },
  {
    path: `/${PREFIX}/liveops/items`,
    name: 'Customization Items',
    component: CustomizationItems,
    underRoutes: CustomizationRoutes,
  },
  {
    path: `/${PREFIX}/liveops/items/:id`,
    component: CustomizationItems,
  },
  {
    path: `/${PREFIX}/liveops/collections/:id?`,
    name: 'Collections',
    component: Collection,
  },
  {
    path: `/${PREFIX}/liveops/liveshows/:id?`,
    name: 'Live Shows',
    component: LiveShows,
  },
  {
    path: `/${PREFIX}/liveops/tournaments/:id?`,
    name: 'Tournaments',
    component: Tournament,
  },
  {
    path: `/${PREFIX}/liveops/specialevent/:id?`,
    name: 'Festivals',
    component: SpecialEvent,
  },
  {
    path: `/${PREFIX}/liveops/hurdle-quiz/:month?/:id?`,
    name: 'Tuneology quizzes',
    component: HurdleQuiz,
  },
  {
    path: `/${PREFIX}/liveops/abtests/:id?`,
    name: 'AB Tests',
    component: ABTests,
  },
  {
    path: `/${PREFIX}/liveops/sale-events/:id?`,
    name: 'Sale Events',
    component: SaleEvent,
  },
  {
    path: `/${PREFIX}/liveops/chained-offers/:id?`,
    name: 'Chained Offers',
    component: ChainedOffer,
  },
  {
    path: `/${PREFIX}/liveops/live-events/:id?`,
    name: 'Live Events',
    component: LiveEvent,
  },
  {
    path: `/${PREFIX}/liveops/team-shop`,
    name: 'Team Shop',
    component: TeamShop,
  },
  {
    path: `/${PREFIX}/liveops/wheel-fortune/:id?`,
    name: 'Wheel Fortune',
    component: WheelFortune,
  },
  {
    path: `/${PREFIX}/liveops/calendars/:id?`,
    name: 'Calendars',
    component: Calendar,
  },
  {
    path: `/${PREFIX}/liveops/marathon/:id?`,
    name: 'Marathon',
    component: Marathon,
  },
  {
    path: `/${PREFIX}/liveops/loyalty-campaign`,
    name: 'Loyalty Campaign',
    component: LoyaltyCampaign,
  },
  {
    path: `/${PREFIX}/liveops/redeem-codes/:id?`,
    name: 'Redeem Codes',
    component: RedeemCodes,
  },
  {
    path: `/${PREFIX}/liveops/progressive-ads`,
    name: 'Progressive Ads',
    component: ProgressiveAds,
  },
];


export default routes;
